<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('routes.appealsByCategoriesAndRegions') }}</h1>
        </div>
        <div class="level-right">
          <div class="control">
            <button @click="loadData(true)" class="button is-success">{{ $t('interface.export') }}</button>
          </div>
        </div>
      </div>
      <!--<div class="level">
        <div class="level-left">
          <div class="field controls is-grouped">
            <div class="control">
              <b-field :label="$t('reports.startDate')">
                <b-datepicker v-model="startDate"
                              @input="loadData()"
                              :month-names="$locale.datePicker().month"
                              :day-names="$locale.datePicker().days"
                              icon="calendar-today">
                </b-datepicker>
              </b-field>
            </div>
            <div class="control">
              <b-field :label="$t('reports.endDate')">
                <b-datepicker v-model="endDate"
                              :min-date="startDate"
                              @input="loadData()"
                              :month-names="$locale.datePicker().month"
                              :day-names="$locale.datePicker().days"
                              icon="calendar-today">
                </b-datepicker>
              </b-field>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="field controls is-grouped">
            <div class="control">
              <b-field :label="$t('reports.department')">
                <b-select v-model="departmentId"
                          @input="loadData()"
                          placeholder="Выберите департамент">
                  <option :value="0">{{ $t('interface.all') }}</option>
                  <option v-for="department in departments"
                          :key="department.id"
                          :value="department.id">
                    {{ department.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="control">
              <b-field :label="$t('reports.category')">
                <b-select v-model="category"
                          @input="loadData()">
                  <option value="incoming">{{ $t('docflow.docTypes.incoming') }}</option>
                  <option value="outgoing">{{ $t('docflow.docTypes.outgoing') }}</option>
                  <option value="appeal">{{ $t('docflow.docTypes.appeals') }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="control" v-if="category === 'incoming'">
              <b-field :label="$t('admin.registerBook')">
                <b-select v-model="registerBook"
                          @input="loadData()">
                  <option :value="0">{{ $t('interface.all') }}</option>
                  <option v-for="registerBook in registerBooks"
                          :key="registerBook.id"
                          :value="registerBook.id">
                    {{ registerBook.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>-->
      <div class="mobile-scroll" ref="report">
        <table class="report-table" border="1">
          <thead>
          <tr>
            <td rowspan="2">№</td>
            <td rowspan="2">{{ $t('docflow.fields.appeal_category') }}</td>
            <td colspan="2"><span class="vt">{{ $t('reports.appealTotal') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.krk') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.and') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.bkh') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.jzh') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.ksh') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.nvo') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.nmg') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.smr') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.srd') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.srh') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.tshr') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.frg') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.khr') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.tshc') }}</span></td>
            <td colspan="2"><span class="vt">{{ $t('regions.other') }}</span></td>
          </tr>
          <tr>
            <template v-for="n in 16">
              <td class="small"><span class="vt">{{ lastYear }}</span></td>
              <td class="small"><span class="vt">{{ currentYear }}</span></td>
            </template>
          </tr>
          </thead>
          <tr v-for="(item, n) in appealsByCategoriesAndRegionsData">
            <td>{{ n+1 }}</td>
            <td>{{ item.name }}</td>
            <td class="small">{{ item.total_ly }}</td>
            <td class="small">{{ item.total_cy }}</td>
            <td class="small">{{ item.karakalpakstan_ly }}</td>
            <td class="small">{{ item.karakalpakstan_cy }}</td>
            <td class="small">{{ item.andijan_ly }}</td>
            <td class="small">{{ item.andijan_cy }}</td>
            <td class="small">{{ item.bukhara_ly }}</td>
            <td class="small">{{ item.bukhara_cy }}</td>
            <td class="small">{{ item.jizzakh_ly }}</td>
            <td class="small">{{ item.jizzakh_cy }}</td>
            <td class="small">{{ item.kashkadarya_ly }}</td>
            <td class="small">{{ item.kashkadarya_cy }}</td>
            <td class="small">{{ item.navai_ly }}</td>
            <td class="small">{{ item.navai_cy }}</td>
            <td class="small">{{ item.namangan_ly }}</td>
            <td class="small">{{ item.namangan_cy }}</td>
            <td class="small">{{ item.samarkand_ly }}</td>
            <td class="small">{{ item.samarkand_cy }}</td>
            <td class="small">{{ item.sirdarya_ly }}</td>
            <td class="small">{{ item.sirdarya_cy }}</td>
            <td class="small">{{ item.surkhandarya_ly }}</td>
            <td class="small">{{ item.surkhandarya_cy }}</td>
            <td class="small">{{ item.tashkent_region_ly }}</td>
            <td class="small">{{ item.tashkent_region_cy }}</td>
            <td class="small">{{ item.ferghana_ly }}</td>
            <td class="small">{{ item.ferghana_cy }}</td>
            <td class="small">{{ item.khorezm_ly }}</td>
            <td class="small">{{ item.khorezm_cy }}</td>
            <td class="small">{{ item.tashkent_ly }}</td>
            <td class="small">{{ item.tashkent_cy }}</td>
            <td class="small">{{ item.others_ly }}</td>
            <td class="small">{{ item.others_cy }}</td>
          </tr>
        </table>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapGetters, mapState, mapActions} from 'vuex'
  import {prepareDate, userDetail, objectToURLParams, outputFile} from '@/utils'
  import {API_HOST} from '@/localSettings'

  let startDate = new Date(),
    endDate = new Date(),
    lastYear = new Date(),
    currentYear = new Date()

  lastYear.setFullYear(lastYear.getFullYear() - 1)

  startDate.setDate(1)
  endDate.setDate(1)
  endDate.setMonth(endDate.getMonth() + 1)

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        departmentId: 0,
        category: 'incoming',
        currentYear: currentYear.getFullYear(),
        lastYear: lastYear.getFullYear(),
        registerBook: 0,
        startDate,
        endDate
      }
    },
    methods: {
      userDetail,
      goTo(route) {
        this.$router.push({name: route})
      },
      loadData(excel = false) {
        let options = {
          start_date: prepareDate(this.startDate),
          end_date: prepareDate(this.endDate),
          category: this.category,
          export: excel
        }
        if (this.departmentId !== 0) options.department = this.departmentId
        if (this.registerBook !== 0) options.register_book = this.registerBook
        this.$store.dispatch('Reports/appealsByCategoriesAndRegions', options).then(() => {
          if (excel) {
            outputFile('report.doc', this.exportData)
          }
        })
      },
      total(items) {
        let total = 0
        items.map(item => total += item.docs_count)
        return total
      }
    },
    mounted() {
      this.$store.commit('Reports/CLEAR', 'appealsByCategoriesAndRegionsData')
      this.$store.dispatch('Reference/getDepartments')
      this.$store.dispatch('Reference/getRegisterBooks')
      this.loadData()
    },
    computed: {
      ...mapState('Reports', ['appealsByCategoriesAndRegionsData', 'exportData']),
      ...mapState('Reference', ['departments', 'registerBooks']),
      breadcrumbs() {
        return [
          {name: 'reportsList', path: 'reportsList'},
          {name: 'appealsByCategoriesAndRegions'}
        ]
      }
    },
    watch: {
      category() {
        this.registerBook = 0
      }
    }
  }
</script>

<style lang="scss" scoped>
  .vt {
    text-align: center;
    writing-mode: tb-rl !important;
    vertical-align: middle;
  }

  td.small {
    font-size: 12px;
    padding: 2px;
    text-align: center;
  }
</style>
